module.exports = __webpack_public_path__ + "static/media/chargext-1.b067d571.jpg";